import React from 'react'
import {useTranslation} from "react-i18next";
import PrimaryButton from "../PrimaryButton";
import './hero.css';

const Hero = ({showCalModal}) => {
    const {t} = useTranslation();

    return (
        <div className="hero-container">
            <div className="hero-card">
                <div className="hero-profile-section">
                    <img alt="Louis Nguyen Profile" src="/profile_picture.jpg" className="hero-profile-image"/>
                    <div className="hero-name-section">
                        <span className="hero-greeting">{t("hero_hi-i-am")}</span>
                        <h1 className="hero-name">Louis Nguyen</h1>
                        <h2 className="hero-title">{t("hero_full-stack-developer")}</h2>
                    </div>
                </div>
                <p className="hero-description">
                    {t("hero_description")}
                </p>
                <div className="hero-actions">
                    <PrimaryButton
                        button={t("hero_button-book-call")}
                        action={showCalModal}
                        size="lg"
                    />
                </div>
            </div>
        </div>
    );
}

export default Hero;
